import templateUrl from './void-check-modal.component.html';

export const VoidCheckModalComponent = {
    templateUrl,
    controller: VoidCheckModalController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
};



function VoidCheckModalController() {
    'ngInject';
    const vm = this;
    vm.$onInit = function () {
        console.log(vm.resolve);
    }
}




export const VoidCheckModal = {
    component: "apexVoidCheckModal",
    windowClass: 'xx-dialog pagespinner',
    //size: 'lg',
    backdrop: 'static'
}
